// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__127zA","loaderOuter":"PageOverlayLoader_loaderOuter__k3MZA"};